<template>
    <div >    
        <v-layout row wrap class="ma-"   >   
            <!-- FIELD --> 
            <template v-for="(item, index) in FIELD_ITEMS" >
                 
                <div v-if="!item.value" :key="index">
                    <v-subheader>
                        {{item.subtitle}} 
                    </v-subheader>
                </div>
                <v-col v-else cols="12" :sm="item.sm" :md="item.md" :key="index" class="py-2"> 
                    <div v-if="item.label_top" :key="1+'-'+index" class="not-f3">{{item.label_top}}</div>
                    <v-text-field 
                        :append-icon="item.append_icon"
                        :dense="item.label_top?true:item.dense?true:false"
                        v-if="item.value=='code'" 
                        :required ="item.required?true:false"  
                        filled=""  :change="UPDATE_MODEL()" 
                        :loading="inputCodeLoading" 
                        :type="item.type"
                        v-model="inputCode" 
                        :label="item.label"
                        :disabled="
                            (update_item && !(item.auto_code?item.auto_code.updatable:false))
                            || (isAutoCode(inputCode) && item.auto_code.disabledIfCode)
                            || DisableField(item)
                        " >
                        <template v-slot:append v-if="item.auto_code && !isAutoCode(inputCode)">
                            <v-btn  v-if="!update_item"
                                :loading="inputCodeLoading"
                                :color="item.auto_code.color?item.auto_code.color:'primary'" 
                                @click="setAutoCode(item.auto_code.values,item.auto_code.notify)"
                                class=" " width=""  
                                depressed  >
                                <v-icon>spellcheck</v-icon>
                                <div class="ml-1 font-weight-bold">
                                    Auto
                                </div>
                            </v-btn> 
                        </template>
                    </v-text-field>  
                    <v-text-field  v-else-if="item.type=='currency'||item.type=='money'"  
                        :append-icon="item.append_icon"
                        :prepend-icon="item.prepend_icon"
                        :prepend-inner-icon="item.prepend_inner_icon"
                        :dense="item.label_top?true:item.dense?true:false"
                        :required ="item.required?true:false"  
                        v-mask="currencyMask"
                        filled="" :change="UPDATE_MODEL()" 
                        :type="item.type"
                        v-model="input[item.value]" 
                        :label="item.label" 
                        :disabled="DisableField(item)" />  
                    <v-textarea  v-else-if="item.type=='textarea'"  
                        :append-icon="item.append_icon"
                        :prepend-icon="item.prepend_icon"
                        :prepend-inner-icon="item.prepend_inner_icon"
                        :dense="item.label_top?true:item.dense?true:false"
                        :required ="item.required?true:false"  
                        filled="" :change="UPDATE_MODEL()" 
                        :type="item.type"
                        v-model="input[item.value]" 
                        :label="item.label" 
                        :disabled="DisableField(item)" />  
                    <v-checkbox  v-else-if="item.type=='checkbox'||item.type=='boolean'"  
                        :append-icon="item.append_icon"
                        :prepend-icon="item.prepend_icon"
                        :prepend-inner-icon="item.prepend_inner_icon"
                        :dense="item.label_top?true:item.dense?true:false"
                        :required ="item.required?true:false"  
                        filled="" :change="UPDATE_MODEL()" 
                        :type="item.type"
                        v-model="input[item.value]" 
                        :label="item.label" 
                        :disabled="DisableField(item)" />  
                    <v-select v-else-if="item.type=='select'" 
                        :append-icon="item.append_icon"
                        :prepend-icon="item.prepend_icon"
                        :prepend-inner-icon="item.prepend_inner_icon"
                        :dense="item.label_top?true:item.dense?true:false"
                        :required ="item.required?true:false"
                        v-model="input[item.value]" 
                        filled :change="UPDATE_MODEL()" 
                        :items="SELECT_ITEMS[item.select?item.select.name:'']"
                        :item-value="item.select?item.select.value:''"
                        :item-text="item.select?item.select.text:''"
                        :label="item.label"
                        :disabled="DisableField(item)" />
                    <v-select v-else-if="item.type=='select_gender'||item.type=='gender'||item.type=='male_female'" 
                        :append-icon="item.append_icon"
                        :prepend-icon="item.prepend_icon"
                        :prepend-inner-icon="item.prepend_inner_icon"
                        :dense="item.label_top?true:item.dense?true:false"
                        v-model="input[item.value]" 
                        filled :change="UPDATE_MODEL()" 
                        :required ="item.required?true:false"
                        :items="['Male','Female']" 
                        :label="item.label"
                        :disabled="DisableField(item)" />
                    <v-select v-else-if="item.type=='select_marital_status'" 
                        :append-icon="item.append_icon"
                        :prepend-icon="item.prepend_icon"
                        :prepend-inner-icon="item.prepend_inner_icon"
                        :dense="item.label_top?true:item.dense?true:false"
                        :required ="item.required?true:false"
                        v-model="input[item.value]" 
                        filled :change="UPDATE_MODEL()" 
                        :items="['Single','Married']" 
                        :label="item.label"
                        :disabled="DisableField(item)" />
                    <v-select v-else-if="item.type=='yes_or_no'" 
                        :append-icon="item.append_icon"
                        :prepend-icon="item.prepend_icon"
                        :prepend-inner-icon="item.prepend_inner_icon"
                        :dense="item.label_top?true:item.dense?true:false"
                        :required ="item.required?true:false"
                        v-model="input[item.value]" 
                        filled :change="UPDATE_MODEL()" 
                        :items="['Yes','No']" 
                        :label="item.label"
                        :disabled="DisableField(item)" />
                        <!-- :items="SELECT_ITEMS?SELECT_ITEMS[item.select?item.select.name:'']:null" -->
                    <v-autocomplete v-else-if="item.type=='autocomplete'" 
                        :append-icon="item.append_icon"
                        :prepend-icon="item.prepend_icon"
                        :prepend-inner-icon="item.prepend_inner_icon"
                        :dense="item.label_top?true:item.dense?true:false"
                        :required ="item.required?true:false"
                        v-model="input[item.value]" 
                        filled @update:search-input="AT_SEARCH_INPUT"
                        :items="GET_SELECT_ITEMS(item)?GET_SELECT_ITEMS(item):null"
                        :item-value="item.select?item.select.value:''"
                        :item-text="item.select?item.select.text:''"
                        :label="item.label"
                        :filter="item.search?item.search.filter:(item, queryText, itemText) => { 
                            let index = (a,b)=>{
                                if(!a||!b){return false}
                                a = ''+a; b = ''+b
                                return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                            } 
                            let first = index(itemText,queryText) 
                            return first  
                        }"
                        :disabled="MBS.actions.SIZE(GET_SELECT_ITEMS(item))?DisableField(item):true" >
                        <template v-slot:prepend-item  v-if="MBS.actions.SIZE(FIELD_APPEND_ACTIONS(item.action))>0 && !search_input">
                            <v-row class="ma-0 pl-3 pr-2">
                                <v-col cols="12" class="px-0"
                                    :sm="MBS.actions.SIZE(FIELD_APPEND_ACTIONS(item.action))==1?'12':'6'" 
                                    v-for="(action,index) in FIELD_APPEND_ACTIONS(item.action)" :key="index">
                                    <v-btn 
                                        :to="action.link"
                                        color="primary" 
                                        @click="FIELDS_ACTION(action)"
                                        class=" my-2" width="97%"  
                                        depressed  >
                                        <v-icon v-if="action.icon">{{action.icon}}</v-icon>
                                        <div class="ml-2 font-weight-bol">
                                            {{action.name}}
                                        </div>
                                    </v-btn> 
                                </v-col> 
                            </v-row>
                        </template>
                        <template v-slot:no-data  >
                            <v-row class="ma-0 pl-3 pr-2" v-if="MBS.actions.SIZE(FIELD_NO_DATA_SEARCH_ACTIONS(item.action))>0 && search_input"> 
                                <v-col cols="12" class="px-0" 
                                    :sm="MBS.actions.SIZE(FIELD_NO_DATA_SEARCH_ACTIONS(item.action))==1?'12':'6'" 
                                    v-for="(action,index) in FIELD_NO_DATA_SEARCH_ACTIONS(item.action)" :key="index">
                                    <v-btn 
                                        :to="action.link"
                                        color="primary" 
                                        @click="FIELDS_ACTION(action,search_input)"
                                        class=" my-2" width="97%"  
                                        depressed  >
                                        <v-icon v-if="action.icon">{{action.icon}}</v-icon> 
                                        <div class="ml-2 font-weight-bol">
                                            {{action.action_name}} "{{search_input}}" {{action.name}}
                                        </div>
                                    </v-btn> 
                                </v-col>  
                            </v-row> 
                            <v-row class="ma-0 pl-3 pr-2" v-if="MBS.actions.SIZE(FIELD_NO_DATA_ACTIONS(item.action))>0"> 
                                <v-col cols="12" class="px-0"
                                    :sm="MBS.actions.SIZE(FIELD_NO_DATA_ACTIONS(item.action))==1?'12':'6'" 
                                    v-for="(action,index) in FIELD_NO_DATA_ACTIONS(item.action)" :key="index">
                                    <v-btn 
                                        :to="action.link"
                                        color="primary" 
                                        @click="FIELDS_ACTION(action,search_input)"
                                        class=" my-2" width="97%"  
                                        depressed  >
                                        <v-icon v-if="action.icon">{{action.icon}}</v-icon> 
                                        <div class="ml-2 font-weight-bol">
                                            {{action.name}}
                                        </div>
                                    </v-btn> 
                                </v-col>  
                            </v-row>
                        </template> 
                        <template v-slot:item="data" v-if="item.search">
                            <template v-if="(typeof data.item !=='object')" >
                            <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>

                            <!-- //ITEM ICON -->
                            <template v-if="item.search.item_icon">
                                <v-list-item-avatar 
                                    :tile="item.search.item_icon.tile"
                                    :color="item.search.item_icon.background_color?item.search.item_icon.background_color:'grey'" > 
                                    <v-icon v-if="item.search.item_icon.name" :color="item.search.item_icon.color">
                                        {{item.search.item_icon.name}}
                                    </v-icon>
                                </v-list-item-avatar> 
                            </template>
                            <v-list-item-content>
                                <!-- //ITEM TITLES -->
                                <template v-for="(title,index) in item.search.item_title">
                                    <v-list-item-title :key="'title'+index">
                                        {{data.item[title]}}
                                    </v-list-item-title> 
                                </template>
                                <!-- //ITEM SUBTITLES -->
                                <template v-for="(subtitle,index) in item.search.item_subtitle">
                                    <v-list-item-subtitle :key="'sub'+index">
                                        {{data.item[subtitle]}}
                                    </v-list-item-subtitle> 
                                </template> 
                            </v-list-item-content>
                            </template>
                        </template>
                    </v-autocomplete>
                    <v-menu  v-else-if="item.type=='date'" 
                        v-model="menu_date_picker[item.value]" 
                        :required ="item.required?true:false"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto" >
                        <template v-slot:activator="{ on, attrs }"> 
                            <v-text-field 
                                :dense="item.label_top?true:item.dense?true:false"
                                :required ="item.required?true:false"
                                v-model="input[item.value]" 
                                :label="item.label"  
                                :append-icon="item.append_icon?append_icon:'mdi-calendar'"
                                :prepend-icon="item.prepend_icon"
                                :prepend-inner-icon="item.prepend_inner_icon"
                                readonly filled
                                v-bind="attrs"
                                v-on="on"
                                :disabled="DisableField(item)"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            :required ="item.required?true:false"
                            v-model="input[item.value]" 
                            :max="item.max?item.max:''"
                            :min="item.min?item.min:''"
                            @input="menu_date_picker[item.value] = false"
                            ></v-date-picker>
                    </v-menu>
                    <v-dialog v-else-if="item.type=='time'" 
                        v-model="dialog_time_picker[item.value]" 
                        persistent
                        width="590px" >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            :dense="item.label_top?true:item.dense?true:false"
                                v-model="input[item.value]" 
                                :label="item.label" 
                                :append-icon="item.append_icon?append_icon:'mdi-calendar'"
                                :prepend-icon="item.prepend_icon"
                                :prepend-inner-icon="item.prepend_inner_icon"
                                readonly filled
                                v-bind="attrs"
                                v-on="on"
                                @click="dialogInput[item.value]=input[item.value]"
                                :disabled="DisableField(item)"
                            ></v-text-field>
                        </template>
                        <v-card v-if="dialog_time_picker[item.value]">
                            <v-time-picker 
                                v-model="dialogInput[item.value]"
                                :max="item.max"
                                :min="item.min"
                                format="24hr"
                                :landscape="$vuetify.breakpoint.smAndUp"
                                full-width > 
                            </v-time-picker>
                            <v-divider class="mt-2"></v-divider>
                            <v-card-actions > 
                                <v-spacer></v-spacer> 
                                <v-btn
                                    text
                                    color="primary"
                                    @click="dialog_time_picker[item.value]= false" >
                                    Cancel
                                </v-btn>
                                <v-btn 
                                    color="primary" text
                                    @click="SAVE_DIALOG_TIME_PICKER(item.value)" >
                                    SAVE
                                </v-btn> 
                            </v-card-actions> 
                        </v-card>
                    </v-dialog>
                    <v-menu  v-else-if="item.type=='time1'" 
                        v-model="menu_time_picker[item.value]" 
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto" >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :dense="item.label_top?true:item.dense?true:false"
                            v-model="input[item.value]" 
                            :label="item.label" :change="UPDATE_MODEL()" 
                            :append-icon="item.append_icon?append_icon:'mdi-calendar'"
                            :prepend-icon="item.prepend_icon"
                            :prepend-inner-icon="item.prepend_inner_icon"
                            readonly filled
                            v-bind="attrs"
                            v-on="on"
                            :disabled="DisableField(item)"
                        ></v-text-field>
                        </template>
                        <v-time-picker
                            v-model="input[item.value]" 
                            :max="item.max?item.max:''"
                            :min="item.min?item.min:''"
                            @input="menu_time_picker[item.value] = false"
                            ></v-time-picker>
                    </v-menu>
                    <v-text-field v-else
                        :dense="item.label_top?true:item.dense?true:false"
                        :required ="item.required?true:false"
                        filled="" :change="UPDATE_MODEL()" 
                        :type="item.type"
                        v-model="input[item.value]" 
                        :label="item.label"
                        :disabled="DisableField(item)"/>  
                </v-col>   
            </template>     
        </v-layout>
        <!-- //DIALOGS -->
        <div>
            <mbs-item-manager 
                :show="false"  
                :name_item="selected_field_action?selected_field_action.NAME_ITEM:null"   
                :field_items="selected_field_action?selected_field_action.fields:null"   
                :path_item="selected_field_action?selected_field_action.path:null"  
                :select_items="SELECT_ITEMS"   
            />   
        </div>
    </div> 
</template>

<script>
    import DATA from '../../plugins/DATA';
    let PAGE_NAME  = "INPUT_FIELDS" 
    
    export default {
        name:PAGE_NAME,
        props:[
            'show','value', 
            'field_items', 
            'select_items', 
            'disabled_fields',  
            'update_item',  
        ],
        data() {
            return { 
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,
  
                excelSelecter:false,
                EXCEL_DATA_ITEMS:[],
                generatedCode:null, 
                inputCode:null, 
                inputCodeLoading:false, 
                menu_date_picker:{},
                menu_time_picker:{},
                dialog_time_picker:{},
                dialogInput:{},
                search:'',  
                search_input:null,   
                input:this.value,
                selected_field_action:null, 
                field_items2:null, 
            }
        },
        created() {
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);   
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try {   
                //SET AUTO CODE
                let input = this.input
                this.field_items2 = this.field_items   
                let items = this.field_items   
                if (items) {
                    items.forEach(field => {
                        //CODE
                        if (field.value == "code") {
                            if (field.auto_code) {
                                if (field.auto_code.onstart && !input.code) {
                                   this.setAutoCode(field.auto_code.values,false) 
                                }
                            }
                        }
                        //DATE
                        if (field.type == "date") {
                            if (field.onstart && !input[field.value]) {
                                let moment = this.MBS.date.moment
                                let today = this.MBS.date.today
                                let tomorrow = this.MBS.date.tomorrow
                                let yesterday = this.MBS.date.yesterday
                                if (field.onstart=="today") {
                                    this.input[field.value] = today
                                }else if (field.onstart=="tomorrow") {
                                    this.input[field.value] = tomorrow
                                }else if (field.onstart=="yesterday") {
                                    this.input[field.value] = yesterday
                                }else{
                                    this.input[field.value] = today
                                }    
                            }
                        } 
                    });
                }
                //
                let code = this.value.code?this.value.code:null
                let generatedCode = this.value.generatedCode?this.value.generatedCode:null
                if (code) {
                    this.inputCode = code
                }if (generatedCode) {
                    this.generatedCode = generatedCode
                } 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: {
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vsh(){
                return this.vs.height
            }, 
            us(){
                return this.$store.getters.getUser
            },
            ud(){
                return this.$store.getters.getUserDetails
            },
            loading(){  
                return this.MBS.actions.loading
            },
            processes(){  
                return this.MBS.actions.processes
            }, 
            responses(){  
                return this.MBS.actions.responses
            }, 
            FIELD_ITEMS(){ 
                let items = null 
                if (this.field_items2) {
                    items = [...this.field_items2]
                }else{
                    items = [
                        {type:"number",name:"code",value:"code",label:"Code",required:true,sm:12,md:12}, 
                        {type:"text",name:"name",value:"name",label:"Name",required:true,sm:12,md:12},   
                    ]  
                } 
                return items
            }, 
            DisableField(){
                let disabled_fields = this.disabled_fields
                return field=>{
                    if(!field){return false}
                    if(!disabled_fields){return field.disabled?true:false}
                    let disabled = disabled_fields.indexOf(field.value)>-1?true:false
                    return disabled
                }
            },
            SELECT_ITEMS(){ 
                let item = this.select_items 
                return item?item:null
            }, 
            GET_SELECT_ITEMS(){  
                return item=>{
                    let select_item = this.SELECT_ITEMS
                    if(!select_item||!item){return null}
                    let name = item.select?item.select.name:null
                    let filter = item.select?item.select.filter:null
                    if(!name){return null}
                    if(!select_item[name]){return null}
                    if(filter){
                        let filter_name = filter.name
                        let filter_input = filter.input 
                        let input = this.input
                        let this_input = input?input[filter_input]:null
                        if(!this_input){return false}
                        return select_item[name].filter(item=>item[filter_input]==this_input)
                    } 
                    return select_item[name]
                } 
            },   
        },
        methods: {  
            FIELD_APPEND_ACTIONS(item){
                try {  
                    if(!item){return null}
                    let newItems = []
                    item.forEach(element => {
                        let link = null
                        let path = null
                        let fields = null
                        let data_item = null
                        let NAME_ITEMS = null
                        let NAME_ITEM = null
                        let VALUE_ITEMS = null
                        let VALUE_ITEM = null
                        if (element.item_values) {
                            fields = DATA.FIELDS[this.MBS.actions.TEXT_UP0(element.item_values)]
                            path = DATA.PATHS[this.MBS.actions.TEXT_UP0(element.item_values)]
                            data_item = DATA.ITEMS[this.MBS.actions.TEXT_UP(element.item_values)]
                        }
                        if (data_item) {
                            NAME_ITEMS = data_item.names
                            NAME_ITEM=data_item.name
                            VALUE_ITEMS=data_item.values
                            VALUE_ITEM=data_item.value
                        }

                        if (element.link) {
                            link = this.MBS.actions.COMPANY_LINK(element.link,element.company_link)
                        }
                            path = this.MBS.actions.COMPANY_LINK(path,element.company_link) 
                        if (element.append) {
                            newItems.push({
                                ...element,
                                fields:fields,
                                data_item:data_item,
                                link:link,
                                path:path,
                                NAME_ITEMS:NAME_ITEMS,
                                NAME_ITEM:NAME_ITEM,
                                VALUE_ITEMS:VALUE_ITEMS,
                                VALUE_ITEM:VALUE_ITEM,
                            }) 
                        }
                    });
                    return newItems
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FIELD_APPEND_ACTIONS',
                        page:PAGE_NAME, 
                    }) 
                } 
            },  
            FIELD_NO_DATA_ACTIONS(item){
                try {  
                    if(!item){return null}
                    let newItems = []
                    item.forEach(element => {
                        let link = null
                        let path = null
                        let fields = null
                        let data_item = null
                        let NAME_ITEMS = null
                        let NAME_ITEM = null
                        let VALUE_ITEMS = null
                        let VALUE_ITEM = null
                        if (element.item_values) {
                            fields = DATA.FIELDS[this.MBS.actions.TEXT_UP0(element.item_values)]
                            path = DATA.PATHS[this.MBS.actions.TEXT_UP0(element.item_values)]
                            data_item = DATA.ITEMS[this.MBS.actions.TEXT_UP(element.item_values)]
                        }
                        if (data_item) {
                            NAME_ITEMS = data_item.names
                            NAME_ITEM=data_item.name
                            VALUE_ITEMS=data_item.values
                            VALUE_ITEM=data_item.value
                        }

                        if (element.link) {
                            link = this.MBS.actions.COMPANY_LINK(element.link,element.company_link)
                        }
                            path = this.MBS.actions.COMPANY_LINK(path,element.company_link) 
                        if (element.no_data) {
                            newItems.push({
                                ...element,
                                fields:fields,
                                data_item:data_item,
                                link:link,
                                path:path,
                                NAME_ITEMS:NAME_ITEMS,
                                NAME_ITEM:NAME_ITEM,
                                VALUE_ITEMS:VALUE_ITEMS,
                                VALUE_ITEM:VALUE_ITEM,
                            }) 
                        }
                    });
                    return newItems
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FIELD_APPEND_ACTIONS',
                        page:PAGE_NAME, 
                    }) 
                } 
            },  
            FIELD_NO_DATA_SEARCH_ACTIONS(item){
                try {  
                    if(!item){return null}
                    let newItems = []
                    item.forEach(element => {
                        let link = null
                        let path = null
                        let fields = null
                        let data_item = null
                        let NAME_ITEMS = null
                        let NAME_ITEM = null
                        let VALUE_ITEMS = null
                        let VALUE_ITEM = null
                        if (element.item_values) {
                            fields = DATA.FIELDS[this.MBS.actions.TEXT_UP0(element.item_values)]
                            data_item = DATA.ITEMS[this.MBS.actions.TEXT_UP(element.item_values)]
                        }
                        if (data_item) {
                            NAME_ITEMS = data_item.names
                            NAME_ITEM=data_item.name
                            VALUE_ITEMS=data_item.values
                            VALUE_ITEM=data_item.value
                        }

                        if (element.link) {
                            link = this.MBS.actions.COMPANY_LINK(element.link,element.company_link)
                        }
                        if ((element.searchable)) {
                            newItems.push({
                                ...element,
                                fields:fields,
                                data_item:data_item,
                                link:link,
                                NAME_ITEMS:NAME_ITEMS,
                                NAME_ITEM:NAME_ITEM,
                                VALUE_ITEMS:VALUE_ITEMS,
                                VALUE_ITEM:VALUE_ITEM,
                            }) 
                        }
                    });
                    return newItems
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FIELD_APPEND_ACTIONS',
                        page:PAGE_NAME, 
                    }) 
                } 
            },  
            FIELDS_ACTION(action){
                try {   
                    this.selected_field_action = action
                    // if (action.action=="add_item") {
                        setTimeout(() => { 
                            this.MBS.events.$emit("ITEM_ACTION",action.action,action)
                        }, 0);
                    // }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FIELD_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            AT_SEARCH_INPUT(input){
                try {  
                    this.search_input = input
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'AT_SEARCH_INPUT',
                        page:PAGE_NAME, 
                    }) 
                } 
            },  
            CREATE_FIELDS_ARRAY_DATA(child,input,notify){
                try { 
                    let code = this.inputCode
                    //CREATE ITEM ARRAY
                    let fields_array_data = {}
                    let required = false
                    let field_items = child?this.FIELD_CHILD_ITEMS:this.FIELD_ITEMS
                    if (input.key) {
                        fields_array_data["key"]=input.key
                    }
                    field_items.forEach(field => {
                        if (field.value==='code') {
                            fields_array_data.code = code 
                        } else {
                            let value = input[field.value]?input[field.value]:null
                            if (!value) {
                                if (field.required) {
                                    if (notify) {
                                        this.MBS.actions.dialog({
                                            show:true,
                                            fixed:false,
                                            title:this.MBS.text.field_required(field.label).title,
                                            text:this.MBS.text.field_required(field.label).text,
                                            btnYes:this.MBS.text.field_required(field.label).btnYes
                                        }) 
                                    }
                                    required = true
                                }
                            }else{
                                fields_array_data[field.value] = value 
                            }
                        } 
                    }); 
                    return {
                        fields_array_data:fields_array_data,
                        required:required
                    }
                         
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CREATE_FIELDS_ARRAY_DATA',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 
            async setAutoCode(values,notify=true){ 
                this.inputCodeLoading = true
                try {
                    if (this.generatedCode) {
                        this.inputCode = this.generatedCode
                        this.inputCodeLoading = false 
                    }else{
                        let res = await this.MBS.actions.CODE_GENERATE(
                            this.MBS.actions.TEXT_UP(values)) 
                        this.inputCode= res.code 
                        this.generatedCode= res.code 
                        this.input.generatedCode= res.code 
                        this.inputCodeLoading = false 
                    }
                    if (notify) {
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:this.MBS.text.generate_code_successful.title,
                            text:this.MBS.text.generate_code_successful.text,
                            btnYes:this.MBS.text.generate_code_successful.btnYes,
                        })   
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'setAutoCode',
                        page:PAGE_NAME, 
                    }) 
                    this.inputCodeLoading = false
                }
            },
            isAutoCode(code){ 
                try {
                    if(!this.generatedCode){return false}
                    if(!code){return false}
                    if (this.generatedCode === code) {
                        return true
                    } 
                } catch (error) {
                   this.MBS.actions.error({
                        error:error,
                        from:'isAutoCode',
                        page:PAGE_NAME, 
                    })  
                }
                return false
            }, 
            
            //---------------[MAIN FUNCTIONS]------------
            SAVE_DIALOG_TIME_PICKER(value){
                try {
                   this.input[value] = this.dialogInput[value] 
                   this.dialog_time_picker[value]= false
                   this.UPDATE_MODEL()
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_MODEL',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            UPDATE_MODEL(){
                try { 
                    this.search_input=null
                    this.$emit('input', {...this.input})
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_MODEL',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {  
                        if (action.code ===PAGE_NAME+'=AUTO-GENERATE-CODE') { 
                            if (action.YES) {
                                this.EXCEL_DATA_ITEMS= this.MBS.actions.CODE_AUTO_GENERATE(this.EXCEL_DATA_ITEMS) 
                                setTimeout(() => { 
                                    this.MBS.actions.dialog({
                                        show:true,
                                        fixed:true,
                                        title:'GENERATED',
                                        text:"Code, successfully generated.",
                                        btnYes:"OK"
                                    }) 
                                }, this.MBS.data.ACTION_REFRESH_TIME); 
                            } else { 
                            }
                        } 
                        if (action.code ===PAGE_NAME+'=AUTO-SET-CODE') { 
                            if (action.YES) {
                                this.inputCodeLoading = true
                                setTimeout(() => { 
                                    this.setAutoCode()
                                }, this.MBS.data.ACTION_REFRESH_TIME); 
                            } else {
                                
                            }
                        } 
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },
              
        },
        beforeDestroy(){
            this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);    
        },
        watch: { 
            us(v){ 
            },  
            input(currentValue) {  
                this.$emit('input', {...currentValue})
            }, 
            inputCode(currentValue) { 
                this.input.code=currentValue
            },    
        },
  }
</script>